module.exports = "<div class=\"privacyAreaContainer\">\n    <div class=\"areaContent\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"readall\" (click)=\"runOpenFullText()\">\n        <span id=\"readAll-{{id}}\" class=\"readAllSpan\">Vai al testo completo</span>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-privacy-area/alg-privacy-area.component.html
// module id = ./src/app/components/molecules/alg-privacy-area/alg-privacy-area.component.html
// module chunks = main